export default __webpack_public_path__ + "static/media/ava.b19b66f3.jpg";